import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteUserSale } from '../../Store/PHPSlice/stockApi';


const TableBody3 = ({
    serialNumber,
    id,
    dt,
    schl_stkId,
    adsaleId,
    memo,
    studNm,
    std,
    div,
    totqty,
    totamt,
    paidamt,
    gst,
    gst_va,
    sts,
    itemId,
    itemNm,
    qty,
    bqty,
    size,
    disrate,
    disamt,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/user-sale-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this User Bill?");
        const data = {
            userId: userdata?.ID,
            usId: id
        };
        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteUserSale(data))
                .then((response) => {
                    console.log("Delete response:", response);
                    // Reload the page to show updated results
                    toast("Bill Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    const handleViewClick = () => {
        window.open(`/user-sale-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    const balamt = parseFloat(totamt) - parseFloat(paidamt);

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000', width: '100px' }} align='center'>
                    {memo}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {studNm}
                </TableCell>

                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {itemNm} 
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell> */}

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>

                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {disrate}
                </TableCell> */}

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {totamt}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {paidamt}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    {balamt}
                </TableCell>

                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>


                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default TableBody3;
